import moment from 'moment';
import { useEffect, useState } from 'react';

interface TimeData {
    durationInMinutes: number;
    hours: number;
    minutes: number;
}

/**
 * Custom hook that calculates time remaining until expiry
 * @param expiryDate - Date string representing expiry time
 * @returns Object containing duration in minutes, hours and minutes or null if no expiry date
 */
const useTimeToExpire = (expiryDate: string | null): Partial<TimeData> => {
    const [timeToExpire, setTimeToExpire] = useState<TimeData | null>(null);

    useEffect(() => {
        if (!expiryDate) return;

        const duration = moment.duration(moment(expiryDate).diff(moment().valueOf()));
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        const durationInMinutes = hours * 60 + minutes;

        setTimeToExpire({
            durationInMinutes,
            hours,
            minutes,
        });
    }, [expiryDate]);

    return timeToExpire || {};
};

export default useTimeToExpire;
